module.exports = __webpack_public_path__ + "img/baibai.4fb6439d.gif";